import { leadStory, hotRanks } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section className="container-x py-6 md:py-10" id="top">
      {/* dual-column: text vs image */}
      <div className="flex flex-col gap-6 lg:flex-row lg:items-stretch">
        {/* left text column */}
        <div className="flex flex-col justify-center lg:w-[55%]">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50 whitespace-nowrap">
              <i className="ri-fire-fill text-sm"></i>
              {leadStory.kicker}
            </span>
            {leadStory.tags.map((t) => (
              <span
                key={t}
                className="rounded-md border border-background-200 bg-background-50 px-2.5 py-1 text-xs font-medium text-foreground-500 whitespace-nowrap"
              >
                {t}
              </span>
            ))}
          </div>

          <h1 className="mt-5 font-heading text-[26px] font-extrabold leading-snug tracking-tight text-foreground-950 md:text-4xl md:leading-snug">
            {leadStory.title}
          </h1>

          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{leadStory.excerpt}</p>

          {/* meta row */}
          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-fire-line text-primary-500"></i>
              {leadStory.meta.hot}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-message-3-line"></i>讨论 {leadStory.meta.comments}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              {leadStory.meta.update}
            </span>
            <span className="inline-flex items-center gap-1.5 text-accent-600">
              <i className="ri-checkbox-circle-fill"></i>前因后果已归档
            </span>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#luntan"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              去讨论区聊
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#shilu"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
            >
              看证据时间轴
            </a>
          </div>
        </div>

        {/* right image column */}
        <div className="relative lg:w-[45%]">
          <div className="relative h-[360px] w-full overflow-hidden rounded-2xl bg-background-200 md:h-[500px]">
            <img
              src={leadStory.image}
              alt="吃瓜网爆今日头条实锤线索图"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            {/* live community badge */}
            <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-black/35 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur md:left-4">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
              </span>
              评论区实时在线
            </div>
            <div className="absolute bottom-3 left-3 right-3 flex items-center gap-3 md:bottom-4 md:left-4 md:right-4">
              <div className="flex -space-x-2">
                {["huo", "gun", "gua", "zha"].map((u) => (
                  <span
                    key={u}
                    className="grid h-8 w-8 place-items-center rounded-full border-2 border-white bg-secondary-200 text-[11px] font-bold text-foreground-700"
                  >
                    {u[0]}
                  </span>
                ))}
              </div>
              <span className="text-xs text-white">2,641 人正在吃这口瓜</span>
            </div>
          </div>
        </div>
      </div>

      {/* heat rank strip under hero */}
      <div className="mt-6 rounded-2xl border border-background-200 bg-background-100 p-4 md:mt-8 md:p-5">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4">
          {hotRanks.map((r) => (
            <a
              key={r.no}
              href="#kuaixun"
              className="flex items-center gap-3 rounded-xl bg-background-50 px-4 py-3 transition-colors hover:border-primary-200"
            >
              <span
                className={`font-heading text-2xl font-extrabold ${
                  r.no === 1 ? "text-primary-500" : "text-background-300"
                }`}
              >
                {String(r.no).padStart(2, "0")}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-foreground-900">{r.title}</span>
                <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="text-accent-600">
                    <i className="ri-arrow-up-line"></i>
                    {r.delta}
                  </span>
                  <span>{r.heat} 热度</span>
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}